import React from 'react'
import { Divider } from '@mui/material'

function InfoCard({data, icon,bgImage}) {
  return (
    <div
      className="client-info-card"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="client-info-card__icon">
        <span className="client-info-card__icon-main">
          <img src={icon} alt="icon" className="client-info-card__icon-image" />
        </span>
        <span className="client-info-card__icon-label">{data?.title}</span>
      </div>
      <div className="client-info-card__content">
        <div className="client-info-card__title">
          {data.firstHeading || "N/A"}
        </div>
        <div className="client-info-card__text">
          {data?.secondaryFirst || ""}
        </div>
        <div className="client-info-card__text">
          {data?.secondarySec || ""}
        </div>
      </div>
    </div>
  );
}

export default InfoCard